import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 4V20M7 20L3 16M7 20L11 16M17 4V20M17 4L21 8M17 4L13 8",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowUpArrowDown;
